import React from 'react';
import SubscriptionDetail from '../billingDetails/SubscriptionDetail';
// eslint-disable-next-line
import CardDetail from '../billingDetails/CardDetail';

const BillingDetail = props => (
  <div className="col-lg-8 dash-main-cntnt edit-profile-cntnt bill-page">
    <title> Prep Day - Account Management </title>
    <div className="dash-cntnt-dtail">
      <div className="swap-mode-dtail-cntnt">
        <SubscriptionDetail {... props} />
        <CardDetail {... props} />
      </div>
    </div>
  </div>
);

export default BillingDetail;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingDetail.js